
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA au Havre dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads au Havre certifiée Google Partner, accompagne les entreprises havraises pour renforcer leur présence en ligne et développer leurs ventes.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads au Havre dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads au Havre certifiée Google Partner, accompagne les entreprises havraises pour renforcer leur présence en ligne et développer leurs ventes.",
        },
      ],
    };
  },
};
